import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
import { Typography } from 'antd';
import {
  ProjectsConstructorLayout,
  useNavigateConstructorTabs,
  ProjectsAddTableForm,
  TableCardsList,
  validateTablesTab,
  ProjectConstructorNavigationControls,
} from '@/views';
import { ProjectDto } from '@/core';
import classes from './ProjectsTablesPage.module.scss';

export const ProjectsTablesPage = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const projectData = useOutletContext<ProjectDto>();
  const { navigateToNextTab, navigateToPreviousTab } = useNavigateConstructorTabs(projectData);
  const isTablesTabValid = validateTablesTab(projectData);
  const isTableWithoutColumns = projectData.tables.some((table) => !table.columns.length);
  const [isErrorNotification, setIsErrorNotification] = useState(false);

  useEffect(() => {
    isTablesTabValid && setIsErrorNotification(false);
  }, [isTablesTabValid, isTableWithoutColumns]);

  const navigateToSheetsTab = () => {
    if (isTableWithoutColumns) {
      return;
    }
    if (!isTablesTabValid) {
      setIsErrorNotification(true);
      return;
    }
    navigateToNextTab();
  };

  return (
    <ProjectsConstructorLayout
      projectData={projectData}
      content={
        <>
          <Typography.Title level={3}>
            {projectData?.name}: {t('addTables.title')}
          </Typography.Title>
          <Typography.Text type="secondary" className={classes.pageDescription}>
            {t('addTables.pageDescription')}
          </Typography.Text>
          <ProjectsAddTableForm projectData={projectData} />
          <TableCardsList
            projectData={projectData}
            isErrorNotification={isErrorNotification}
            isTableWithoutColumns={isTableWithoutColumns}
            isTablesTabValid={isTablesTabValid}
          />
        </>
      }
      navigationControls={
        <ProjectConstructorNavigationControls
          navigateToPreviousTab={navigateToPreviousTab}
          navigateToNextTab={navigateToSheetsTab}
        />
      }
    />
  );
};
